import React from 'react';
import { motion } from 'framer-motion';
import { MegaphoneIcon, Target as TargetIcon, LayersIcon, BrainCircuitIcon } from 'lucide-react';
const SERVICES = [{
  icon: MegaphoneIcon,
  title: 'Marketing',
  description: 'Estrategias de posicionamiento y contenido diseñadas para atraer clientes de forma constante.'
}, {
  icon: TargetIcon,
  title: 'Publicidad Digital',
  description: 'Campañas medibles en Meta y Google, optimizadas para reducir costos y escalar resultados.'
}, {
  icon: LayersIcon,
  title: 'Productos Digitales',
  description: 'eBooks, plantillas y recursos descargables listos para vender y para implementar hoy.'
}, {
  icon: BrainCircuitIcon,
  title: 'Inteligencia Artificial',
  description: 'Flujos y prompts con IA que automatizan el contenido, la atención y la operación diaria.'
}];
export function WhatWeDo() {
  return <section id="servicios" className="relative w-full border-t border-white/[0.06] py-28 sm:py-32 lg:py-40" data-id="element-504" data-mp="ipiuvzji7zq6">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-505" data-mp="3mfqfxst37s60">
        <div className="max-w-2xl" data-id="element-506" data-mp="3heauw0qwtlnm">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-white/35" data-id="element-507" data-mp="3hh6wbz1yusgt">
            Qué hacemos
          </p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-white sm:text-[2.6rem]" data-id="element-508" data-mp="3rcqms5xrgyy6">
            Cuatro capacidades, un mismo objetivo:{' '}
            <span className="text-white/45" data-id="element-509" data-mp="2yocpxties8o7">hacer crecer tu negocio.</span>
          </h2>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-510" data-mp="3dd8w1l0wnbm6">
          {SERVICES.map((service, i) => <motion.li key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="group relative overflow-hidden rounded-3xl border border-white/[0.07] bg-white/[0.02] p-8 sm:p-9 transition-colors duration-300 hover:border-white/[0.16]" data-id="element-511" data-mp="38lh9rmos7s1u" data-mpi={i}>
              <div aria-hidden="true" className="pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100" style={{
            background: 'radial-gradient(circle, rgba(37,99,246,0.28), transparent 70%)'
          }} data-id="element-512" data-mp="3jddtjsm8nd7y" />
              <span className="relative grid h-11 w-11 place-items-center rounded-2xl border border-white/[0.12] bg-white/[0.05] backdrop-blur-md" data-id="element-513" data-mp="30mw1zrd56no6">
                <service.icon aria-hidden="true" className="h-5 w-5 text-[#7fa3ff]" strokeWidth={1.5} data-id="element-514" data-mp="awskkbtlwk4u" />
              </span>
              <h3 className="relative mt-7 text-[17px] font-medium tracking-tight text-white" data-id="element-515" data-mp="20debm9lu6am4">
                {service.title}
              </h3>
              <p className="relative mt-4 text-[14px] font-light leading-relaxed text-white/45" data-id="element-516" data-mp="1qowec2crmln8">
                {service.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}